import { updateRoleAsyncResponse } from "./types";
import * as roleActions from "./roles.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiPut, API_URL_ROLE, retrieveToken } from "../../../helpers/api";

export function* updateRoles(action: ReturnType<typeof roleActions.updateRoleAsync.request>) {
  try {
    const token: string = yield retrieveToken();
    if (action.payload.id) {
      const result: Response = yield call(apiPut, API_URL_ROLE.UPDATE_ROLE(action.payload.id), token, action.payload);
      if (result.status === 200) {
        const parsed: updateRoleAsyncResponse = yield call(result.json.bind(result));
        yield put(roleActions.updateRoleAsync.success(parsed));
        return;
      } else {
        const parsed: ErrorResponse = yield call(result.json.bind(result));
        yield put(roleActions.updateRoleAsync.failure(parsed));
        return;
      }
    } else {
      const parsed: ErrorResponse = {
        status: 500,
        errors: {},
        message: 'Terjadi kesalahan pada server'
      }
      yield put(roleActions.updateRoleAsync.failure(parsed));  
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(roleActions.updateRoleAsync.failure(parsed));
  }
}

export default function* rolesSagaUpdateRole() {
  yield takeEvery(roleActions.updateRoleAsync.request, updateRoles);
}
